import React, { FC, useEffect, useState } from "react";
import { DEF_PG_SIZE_SUB } from "../../../constants/maximum-page-size";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import CertificateAuditColumns from "../../../models/ColumnDefinitions/CertificateAuditColumns";
import { ListData } from "../../../models/ListData";
import { ListQuery } from "../../../models/ListQuery";
import CertificateAuditSearch from "../../../models/search/CertificateAuditSearch";
import { getCertificateAudit } from "../../../services/certificateAuditService";
import { appendFilter } from "../../../utilities/filters";
import TableTab from "../../tabs/table-tab";

interface Props {
    controllerId: number;
}

const AuditTab: FC<Props> = ({ controllerId  }) => {
    const { translate } = useLocale();

    const getTableData = (listParameters?) => {
        return getCertificateAudit(controllerId.toString(),
            {
                ...listParameters,
                filters: appendFilter(controllerId, 'Controller', 'controllerId', listParameters?.filters)
            },
            translate);
    }

    // default to a method that returns nothing
    // when putting a method in a state variable, useState requires us to return the method from a method, hence the wrapped inner method.
    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });

    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    useEffect(() => {
        dataRefresh(getTableData);
    }, [controllerId, translate])

    return (<TableContextProvider
            dataMethod={(listParameters) => getTableData(listParameters)}
            manualDataRefresh={manualDataRefresh}
            tableDescriptor={CertificateAuditColumns}
            searchDescriptor={CertificateAuditSearch}
            useFilter
            useSearch
            usePagination
            maxPageSize={DEF_PG_SIZE_SUB}
            useTable>
            <TableTab
                title={''}
                reportTitle={translate.byKey(TranslationKeys.audit)}
                selectRows={false}
                showFilterMenu={false}
                disableFilterToggling={true}
                cyName="certificateAudit">
            </TableTab>
        </TableContextProvider>
    );
};

export default AuditTab;
